import React from 'react';
import css from './StackedColumn.module.css';
import clsx from 'clsx';
import { StackedColumnSpacing } from './StackedColumnSpacing';

export interface StackedColumnProps {
  spacing?: StackedColumnSpacing;
  fillHeight?: boolean;
  children: React.ReactNode;
}

const StackedColumn: React.FC<StackedColumnProps> = (
  props: StackedColumnProps
) => {
  const { spacing = StackedColumnSpacing.Normal, fillHeight = false } = props;
  return (
    <div
      className={clsx(
        css.container,
        spacing === StackedColumnSpacing.Wide
          ? css.wide
          : spacing === StackedColumnSpacing.Wider
          ? css.wider
          : spacing === StackedColumnSpacing.Tight
          ? css.tight
          : spacing === StackedColumnSpacing.NoGap
          ? css.nogap
          : css.normal,
        fillHeight ? css.fillHeight : null
      )}
    >
      {props.children}
    </div>
  );
};

export default StackedColumn;
